import Image from "next/image";
import { LinkWithChannel } from "@/ui/atoms/link-with-channel";
import { brandConfig } from "@/config/brand";
import { cn } from "@/lib/utils";

const BRAND_WORDMARK_TEXT = "Eurolabs Peptides";
const BRAND_LOGO = {
	src: "/euro-lab-logo.webp",
	width: 1521,
	height: 1034,
} as const;

interface BrandWordmarkProps {
	className?: string;
	/** Matches the persistent header logo; larger presentations can override it. */
	sizes?: string;
}

export const BrandWordmark = ({ className }: BrandWordmarkProps) => {
	return (
		<span
			className={cn(
				"inline-flex items-center whitespace-nowrap font-semibold tracking-tight text-black dark:text-white",
				className,
			)}
		>
			{BRAND_WORDMARK_TEXT}
		</span>
	);
};

export const BrandHomeLink = ({
	className,
	sizes = "(min-width: 1024px) 94px, (min-width: 640px) 83px, 71px",
}: BrandWordmarkProps) => {
	return (
		<LinkWithChannel
			href="/"
			className="flex min-w-0 shrink items-center"
			aria-label={brandConfig.logoAriaLabel}
		>
			<Image
				src={BRAND_LOGO.src}
				alt={brandConfig.logoAriaLabel}
				width={BRAND_LOGO.width}
				height={BRAND_LOGO.height}
				sizes={sizes}
				priority
				className={cn("h-12 w-auto sm:h-14 lg:h-16", className)}
			/>
		</LinkWithChannel>
	);
};
